
import { createRouter, createWebHashHistory } from 'vue-router';

import { useAuth } from 'src/composables/auth';


function passRouteToProps(route){
	return {
		queryParams: route.query,
		fieldName: route.params.fieldName, 
		fieldValue: route.params.fieldValue
	}
}


let routes = [
	// Bandeja "Mis pendientes" (cualquier usuario con sesión; ver sessionPages en composables/auth.js)
			{
				path: '/pendientes',
				name: 'pendientes',
				component: () => import('./pages/pendientes/index.vue'),
				props: { routeName: 'pendientes' }
			},

	//Dashboard routes
			{
				path: '/home/quotations',
				name: 'home_quotations',
				component: () => import('./pages/home/home_quotations.vue'),
				props: true
			},

//authtable routes
			{
				path: '/authtable/:fieldName?/:fieldValue?',
				name: 'authtablelist',
				component: () => import('./pages/authtable/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/authtable/view/:id', 
				name: 'authtableview', 
				component: () => import('./pages/authtable/view.vue'), 
				props: true
			},
		
			{ 
				path: '/index/register', 
				name: 'authtableuserregister', 
				component: () => import('./pages/index/userregister.vue'), 
				props: true
			},
	
			{ 
				path: '/account/edit', 
				name: 'authtableaccountedit', 
				component: () => import('./pages/account/accountedit.vue'), 
				props: true
			},
	
			{ 
				path: '/account', 
				name: 'authtableaccountview', 
				component: () => import('./pages/account/accountview.vue'), 
				props: true
			},
	
			{ 
				path: '/authtable/add', 
				name: 'authtableadd', 
				component: () => import('./pages/authtable/add.vue'), 
				props: true
			},
	
			{ 
				path: '/authtable/edit/:id', 
				name: 'authtableedit', 
				component: () => import('./pages/authtable/edit.vue'), 
				props: true
			},
		

//clients routes
			{
				path: '/clients/:fieldName?/:fieldValue?',
				name: 'clientslist',
				component: () => import('./pages/clients/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/clients/view/:id', 
				name: 'clientsview', 
				component: () => import('./pages/clients/view.vue'), 
				props: true
			},
		
			{
				path: '/clients/add',
				name: 'clientsadd',
				component: () => import('./pages/clients/add.vue'),
			},

			{
				path: '/clients/edit/:id',
				name: 'clientsedit', 
				component: () => import('./pages/clients/edit.vue'), 
				props: true
			},
		

//email_recipients routes
		{
			path: '/admin/email_recipients',
			name: 'emailrecipientslist',
			component: () => import('./pages/emailrecipients/list.vue'),
		},

//employees routes
		{
			path: '/employees',
			name: 'employeeslist',
			component: () => import('./pages/employees/list.vue'),
		},

// Gestión de documentos del empleado (permiso employee_documents/index)
		{
			path: '/employee_documents/index/:id',
			name: 'employeesview',
			component: () => import('./pages/employees/view.vue'),
			props: true
		},

//attendance-projects routes
		{
			path: '/attendance-projects',
			name: 'attendanceprojectslist',
			component: () => import('./pages/attendance-projects/list.vue'),
		},

//attendance routes
		{
			path: '/attendance',
			name: 'attendancelist',
			component: () => import('./pages/attendance/list.vue'),
		},
		{
			path: '/dashboard',
			name: 'attendancedashboard',
			component: () => import('./pages/attendance/dashboard.vue'),
		},

//vacaciones routes
		{
			path: '/vacaciones',
			name: 'vacacioneslist',
			component: () => import('./pages/vacaciones/list.vue'),
		},

//vehículos routes (catálogo + revisiones que se capturan en la app móvil)
		{
			path: '/vehicles',
			name: 'vehicleslist',
			component: () => import('./pages/vehicles/list.vue'),
		},
		{
			path: '/vehicle_inspections',
			name: 'vehicleinspectionslist',
			component: () => import('./pages/vehicle_inspections/list.vue'),
		},
		{
			path: '/vehicle_services',
			name: 'vehicleserviceslist',
			component: () => import('./pages/vehicle_services/list.vue'),
		},
		{
			path: '/vehicle_events',
			name: 'vehicleeventslist',
			component: () => import('./pages/vehicle_events/list.vue'),
		},

//roles routes
			{
				path: '/roles/:fieldName?/:fieldValue?',
				name: 'roleslist',
				component: () => import('./pages/roles/list.vue'),
				props: route => passRouteToProps(route)
			},

			{
				path: '/roles/view/:id',
				name: 'rolesview',
				component: () => import('./pages/roles/view.vue'),
				props: true
			},

			{
				path: '/roles/add',
				name: 'rolesadd',
				component: () => import('./pages/roles/add.vue'),
				props: true
			},

			{
				path: '/roles/edit/:id',
				name: 'rolesedit',
				component: () => import('./pages/roles/edit.vue'),
				props: true
			},

//project_types routes (catálogo de TIPO del reporte de avances)
			{
				path: '/project_types/:fieldName?/:fieldValue?',
				name: 'project_typeslist',
				component: () => import('./pages/project_types/list.vue'),
				props: route => passRouteToProps(route)
			},

			{
				path: '/project_types/view/:id',
				name: 'project_typesview',
				component: () => import('./pages/project_types/view.vue'),
				props: true
			},

			{
				path: '/project_types/add',
				name: 'project_typesadd',
				component: () => import('./pages/project_types/add.vue'),
				props: true
			},

			{
				path: '/project_types/edit/:id',
				name: 'project_typesedit',
				component: () => import('./pages/project_types/edit.vue'),
				props: true
			},

//definiciones_alcance routes (catálogo administrable del módulo Presupuestos)
			{
				path: '/definiciones_alcance/:fieldName?/:fieldValue?',
				name: 'definiciones_alcancelist',
				component: () => import('./pages/definiciones_alcance/list.vue'),
				props: route => passRouteToProps(route)
			},
			{
				path: '/definiciones_alcance/view/:id',
				name: 'definiciones_alcanceview',
				component: () => import('./pages/definiciones_alcance/view.vue'),
				props: true
			},
			{
				path: '/definiciones_alcance/add',
				name: 'definiciones_alcanceadd',
				component: () => import('./pages/definiciones_alcance/add.vue'),
				props: true
			},
			{
				path: '/definiciones_alcance/edit/:id',
				name: 'definiciones_alcanceedit',
				component: () => import('./pages/definiciones_alcance/edit.vue'),
				props: true
			},

//unidades routes (catálogo de unidades de medida)
			{
				path: '/unidades/:fieldName?/:fieldValue?',
				name: 'unidadeslist',
				component: () => import('./pages/unidades/list.vue'),
				props: route => passRouteToProps(route)
			},

			{
				path: '/unidades/view/:id',
				name: 'unidadesview',
				component: () => import('./pages/unidades/view.vue'),
				props: true
			},

			{
				path: '/unidades/add',
				name: 'unidadesadd',
				component: () => import('./pages/unidades/add.vue'),
				props: true
			},

			{
				path: '/unidades/edit/:id',
				name: 'unidadesedit',
				component: () => import('./pages/unidades/edit.vue'),
				props: true
			},

//filiales routes (catálogo de filiales/organizaciones)
			{
				path: '/filiales/:fieldName?/:fieldValue?',
				name: 'filialeslist',
				component: () => import('./pages/filiales/list.vue'),
				props: route => passRouteToProps(route)
			},

			{
				path: '/filiales/view/:id',
				name: 'filialesview',
				component: () => import('./pages/filiales/view.vue'),
				props: true
			},

			{
				path: '/filiales/add',
				name: 'filialesadd',
				component: () => import('./pages/filiales/add.vue'),
				props: true
			},

			{
				path: '/filiales/edit/:id',
				name: 'filialesedit',
				component: () => import('./pages/filiales/edit.vue'),
				props: true
			},

//vendors routes (catálogo de proveedores)
			{
				path: '/vendors/:fieldName?/:fieldValue?',
				name: 'vendorslist',
				component: () => import('./pages/vendors/list.vue'),
				props: route => passRouteToProps(route)
			},

			{
				path: '/vendors/view/:id',
				name: 'vendorsview',
				component: () => import('./pages/vendors/view.vue'),
				props: true
			},

			{
				path: '/vendors/add',
				name: 'vendorsadd',
				component: () => import('./pages/vendors/add.vue'),
				props: true
			},

			{
				path: '/vendors/edit/:id',
				name: 'vendorsedit',
				component: () => import('./pages/vendors/edit.vue'),
				props: true
			},

//presupuestos routes (módulo nuevo, independiente de insumos/cotizacion_conceptos)
			{
				path: '/presupuestos/:fieldName?/:fieldValue?',
				name: 'presupuestoslist',
				component: () => import('./pages/presupuestos/list.vue'),
				props: route => passRouteToProps(route)
			},

			{
				path: '/presupuestos/view/:id',
				name: 'presupuestosview',
				component: () => import('./pages/presupuestos/view.vue'),
				props: true
			},

			{
				path: '/presupuestos/add',
				name: 'presupuestosadd',
				component: () => import('./pages/presupuestos/add.vue'),
				props: true
			},

			{
				path: '/presupuestos/edit/:id',
				name: 'presupuestosedit',
				component: () => import('./pages/presupuestos/edit.vue'),
				props: true
			},

			{
				path: '/presupuestos/insumos/:id',
				name: 'presupuestosinsumos',
				component: () => import('./pages/presupuestos/gestion.vue'),
				props: true
			},

			{
				path: '/presupuestos/analisis/:id',
				name: 'presupuestosanalisis',
				component: () => import('./pages/presupuestos/analisis.vue'),
				props: true
			},

//project_executions routes (Módulo de Ejecución de Proyectos)
			{
				path: '/project_executions/list_admin',
				name: 'projectexecutionslistadmin',
				component: () => import('./pages/project_executions/list.vue'),
				props: { apiPath: 'project_executions/list_admin', scope: 'admin', routeName: 'projectexecutionslistadmin' }
			},
			{
				path: '/project_executions/list_user',
				name: 'projectexecutionslistuser',
				component: () => import('./pages/project_executions/list.vue'),
				props: { apiPath: 'project_executions/list_user', scope: 'mine', routeName: 'projectexecutionslistuser' }
			},
			{
				path: '/project_executions/dashboard_admin',
				name: 'projectexecutionsdashboardadmin',
				component: () => import('./pages/project_executions/dashboard.vue'),
				props: { scope: 'admin', routeName: 'projectexecutionsdashboardadmin' }
			},
			{
				path: '/project_executions/dashboard_user',
				name: 'projectexecutionsdashboarduser',
				component: () => import('./pages/project_executions/dashboard.vue'),
				props: { scope: 'mine', routeName: 'projectexecutionsdashboarduser' }
			},
			{
				path: '/project_executions/view/:id',
				name: 'projectexecutionsview',
				component: () => import('./pages/project_executions/view.vue'),
				props: true
			},
			{
				path: '/project_executions/report/:id',
				name: 'projectexecutionsreport',
				component: () => import('./pages/project_executions/report.vue'),
				props: true
			},
			{
				path: '/project_executions/cashflow/:id',
				name: 'projectexecutionscashflow',
				component: () => import('./pages/project_executions/flujo.vue'),
				props: true
			},

//purchase_orders routes (Órdenes de Compra generadas al aprobar una Requisición)
			{
				path: '/purchase_orders/:fieldName?/:fieldValue?',
				name: 'purchaseorderslist',
				component: () => import('./pages/purchase_orders/list.vue'),
				props: route => passRouteToProps(route)
			},

			{
				path: '/purchase_orders/view/:id',
				name: 'purchaseordersview',
				component: () => import('./pages/purchase_orders/view.vue'),
				props: true
			},

			{
				path: '/purchase_orders/settings',
				name: 'purchaseorderssettings',
				component: () => import('./pages/purchase_orders/settings.vue'),
				props: true
			},

			{
				path: '/purchase_orders/create_extraordinary',
				name: 'purchaseorderscreateextraordinary',
				component: () => import('./pages/purchase_orders/create_extraordinary.vue'),
				props: true
			},

//documents routes (catálogo de tipos de documento)
			// Asistencia → "Documentos de empleados": el mismo catálogo filtrado (/documents/index/applies_to/empleado).
			{
				path: '/documents/index/:fieldName/:fieldValue',
				name: 'documentsindexfiltered',
				component: () => import('./pages/documents/list.vue'),
				props: route => passRouteToProps(route)
			},
			{
				path: '/documents/:fieldName?/:fieldValue?',
				name: 'documentslist',
				component: () => import('./pages/documents/list.vue'),
				props: route => passRouteToProps(route)
			},

			{
				path: '/documents/view/:id',
				name: 'documentsview',
				component: () => import('./pages/documents/view.vue'),
				props: true
			},

			{
				path: '/documents/add',
				name: 'documentsadd',
				component: () => import('./pages/documents/add.vue'),
				props: true
			},

			{
				path: '/documents/edit/:id',
				name: 'documentsedit',
				component: () => import('./pages/documents/edit.vue'),
				props: true
			},

//requisiciones routes
			{
				path: '/requisiciones/:fieldName?/:fieldValue?',
				name: 'requisicioneslist',
				component: () => import('./pages/requisiciones/list.vue'),
				props: route => passRouteToProps(route)
			},

			{
				path: '/requisiciones/view/:id',
				name: 'requisicionesview',
				component: () => import('./pages/requisiciones/view.vue'),
				props: true
			},

			{
				path: '/requisiciones/add',
				name: 'requisicionesadd',
				component: () => import('./pages/requisiciones/add.vue'),
				props: true
			},

			{
				path: '/requisiciones/edit/:id',
				name: 'requisicionesedit',
				component: () => import('./pages/requisiciones/edit.vue'),
				props: true
			},

//audits routes (auditoría de todo el proyecto)
			{
				path: '/audits',
				name: 'auditslist',
				component: () => import('./pages/audits/list.vue'),
				props: true
			},

//permissions routes
			{
				path: '/permissions/:fieldName?/:fieldValue?',
				name: 'permissionslist',
				component: () => import('./pages/permissions/list.vue'),
				props: route => passRouteToProps(route)
			},

			{
				path: '/permissions/view/:id',
				name: 'permissionsview',
				component: () => import('./pages/permissions/view.vue'),
				props: true
			},

			{
				path: '/permissions/add',
				name: 'permissionsadd',
				component: () => import('./pages/permissions/add.vue'),
				props: true
			},

			{
				path: '/permissions/edit/:id',
				name: 'permissionsedit',
				component: () => import('./pages/permissions/edit.vue'),
				props: true
			},

//modules routes
			{
				path: '/modules/:fieldName?/:fieldValue?',
				name: 'moduleslist',
				component: () => import('./pages/modules/list.vue'),
				props: route => passRouteToProps(route)
			},
			{
				path: '/modules/view/:id',
				name: 'modulesview',
				component: () => import('./pages/modules/view.vue'),
				props: true
			},
			{
				path: '/modules/add',
				name: 'modulesadd',
				component: () => import('./pages/modules/add.vue'),
				props: true
			},
			{
				path: '/modules/edit/:id',
				name: 'modulesedit',
				component: () => import('./pages/modules/edit.vue'),
				props: true
			},

//projects routes

			{
				path: '/projects/seguimiento/:fieldName?/:fieldValue?',
				name: 'projectsseguimiento',
				component: () => import('./pages/projects/seguimiento.vue'), 
				props: route => passRouteToProps(route)
			},
	
		
			{
				path: '/projects/costosfirmadas/:fieldName?/:fieldValue?',
				name: 'projectscostosfirmadas',
				component: () => import('./pages/projects/costosfirmadas.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{
				path: '/projects/semanasmes/:fieldName?/:fieldValue?',
				name: 'projectssemanasmes',
				component: () => import('./pages/projects/semanasmes.vue'), 
				props: route => passRouteToProps(route)
			},
			{
				path: '/projects/seguimientoadmin/:fieldName?/:fieldValue?',
				name: 'projectsseguimientoadmin',
				component: () => import('./pages/projects/seguimientoadmin.vue'), 
				props: route => passRouteToProps(route)
			},

			{
				path: '/projects/salesfunnel/:fieldName?/:fieldValue?',
				name: 'projectssalesfunnel',
				component: () => import('./pages/salesfunnel/salesfunnel.vue'),
				props: route => passRouteToProps(route)
			},
		
		
//request proposal routes
{
	path: '/request_proposal/:fieldName?/:fieldValue?',
	name: 'requestproposallist',
	component: () => import('./pages/requestproposal/list.vue'), 
	props: route => passRouteToProps(route)
},
{ 
	path: '/request_proposal/view/:id', 
	name: 'requestproposalview', 
	component: () => import('./pages/requestproposal/view.vue'), 
	props: true
},
{ 
	path: '/request_proposal/add', 
	name: 'requestproposaladd', 
	component: () => import('./pages/requestproposal/add.vue'), 
	props: true
},
{ 
	path: '/request_proposal/edit/:id', 
	name: 'requestproposallistedit', 
	component: () => import('./pages/requestproposal/edit.vue'), 
	props: true
},




	
	
//Password reset routes
			{ 
				path: '/index/forgotpassword', 
				name: 'forgotpassword', 
				component: () => import('./pages/index/forgotpassword.vue'), 
				props: true
			},
			{ 
				path: '/index/resetpassword', 
				name: 'resetpassword', 
				component: () => import('./pages/index/resetpassword.vue'), 
				props: true
			},
			{ 
				path: '/index/resetpassword_completed', 
				name: 'resetpassword_completed', 
				component: () => import('./pages/index/resetpassword_completed.vue'), 
				props: true
			},
			{ 
				path: '/index/traccar', 
				name: 'traccar', 
				component: () => import('./pages/index/traccar.vue'), 
				props: true
			},
	

    { 
        path: '/admin/actions', 
        name: 'actions', 
        component: () => import('./pages/actions/home.vue'), 
    },
	
	
	{ 
		path:  '/error/forbidden', 
		name: 'forbidden', 
		component: () => import('./pages/errors/forbidden.vue'),
		props: true
	},
	{ 
		path: '/error/notfound', 
		name: 'notfound',
		component: () => import('./pages/errors/pagenotfound.vue'),
		props: true
	},
	{
		path: '/:catchAll(.*)', 
		component: () => import('./pages/errors/pagenotfound.vue')
	},
	{
		path: '/survey',
		name: 'surveyform',
		component: () => import('./pages/survey/form.vue'),
		props: true
	},
	{
		path: '/vacaciones/confirmar',
		name: 'vacacionesconfirm',
		component: () => import('./pages/vacaciones/confirm.vue'),
		props: true
	},
	{
		path: '/requisiciones/confirmar',
		name: 'requisicionesconfirm',
		component: () => import('./pages/requisiciones/confirm.vue'),
		props: true
	},

];

export default () => {
	
const auth = useAuth();

	
	const user = auth.user;
	if(user){
		routes.push({ path: '/', alias: '/home', name: 'home', component: () => import(`./pages/home/home.vue`) });
	}
	else{
		routes.push({ path: '/', alias: '/index', name: 'index', component: () => import('./pages/index/index.vue') });
	}

	const router = createRouter({
		history: createWebHashHistory(),
		routes,
		scrollBehavior(to, from, savedPostion){
			if(savedPostion) return savedPostion;
			return { top:0 }
		}
	});
	
	router.beforeEach((to, from, next) => {
		const user = auth.user;
		let path = to.path;
		let authRequired = auth.pageRequiredAuth(path);
		if (to.name === 'surveyform' && to.query.token) {
			return next();
		}
		if (to.name === 'vacacionesconfirm' && to.query.token) {
			return next();
		}
		if (to.name === 'requisicionesconfirm' && to.query.token) {
			return next();
		}

		if (authRequired) {
			if(!user){
				return next({ path: '/',  query: { nexturl: to.fullPath } });
			}
			//authorize user
			if (!auth.canView(path)) {
				return next({path: "/error/forbidden"});
			}
		}

		if(user && to.name == "index"){
			//already logged in, show home when try to access index page
			return next({ path: "/home"});
		}

		//navigate to redirect url if available
		if(to.name == "home" && to.query.nexturl){
			return next({ path: to.query.nexturl});
		}

		// El inicio es el tablero de solicitudes de cotización; quien no trabaja
		// solicitudes (compras, PM, RH...) aterriza en su bandeja de pendientes.
		// Coordinador conserva su landing de asistencia.
		if(user && to.name == "home" && !auth.isCoordinador && !auth.hasPermission('request_proposal/index')){
			return next({ path: "/pendientes"});
		}

 		//close dialog from previous page
		//store.closeDialogs('app/closeDialogs');
		
		next();
	});

	return router;
}
